import { Outlet } from 'react-router-dom';
import { SidebarProvider } from '@/context/SidebarContext';
import Sidebar from './Sidebar';
import Header from './Header';
import { Eye } from 'lucide-react';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { selectHideHeader, setHideHeader } from '@/store/slices/uiSlice';

/**
 * Dashboard layout with sidebar + header + content area.
 * Used for all authenticated/dashboard pages.
 */
export function DashboardLayout() {
    const dispatch = useAppDispatch();
    const hideHeader = useAppSelector(selectHideHeader);

    return (
        <SidebarProvider>
            <div className="flex h-screen h-dvh overflow-hidden">
                <Sidebar />
                <div className="flex flex-1 flex-col overflow-hidden">
                    {!hideHeader ? <Header /> : null}
                    {hideHeader ? (
                        <button
                            type="button"
                            onClick={() => dispatch(setHideHeader(false))}
                            className="fixed top-3 right-3 z-[80] inline-flex items-center gap-2 rounded-md border border-border bg-card px-3 py-2 text-sm font-semibold text-foreground shadow-sm hover:bg-muted"
                            aria-label="Show header"
                            title="Show header"
                        >
                            <Eye className="h-4 w-4" aria-hidden />
                            Show header
                        </button>
                    ) : null}
                    <main className="flex-1 overflow-y-auto p-6">
                        <Outlet />
                    </main>
                </div>
            </div>
        </SidebarProvider>
    );
}

export default DashboardLayout;
